import React from "react"
import DateButtonsRow from "./DateButtonsRow"
import strings from "../../localization/strings"
import autobind from "class-autobind"
import moment from "moment"
import { EDayOfWeek} from "../../models"

interface IProps {
    onDateChange(newDate: Date | string): void
}
interface IState {
    startDate: Date | string
    endDate: Date | string
    timecardHintDate: Date
    previousIconHover: boolean
    nextIconHover: boolean
}

export default class EquipmentTimecardActionBar extends React.Component<IProps, IState>  {
    constructor(props) {
        super(props)
        this.state = {
            startDate: null,
            endDate: null,
            timecardHintDate: moment().toDate(),
            previousIconHover: false,
            nextIconHover: false,
        }
        autobind(this)
    }

    componentDidMount() {
        this.getDates()
    }

    obtainNewDates(timecardHintDate) {
        this.setState({ timecardHintDate }, () => {
            this.getDates()
            this.props.onDateChange(this.state.timecardHintDate)
        })
    }

    onGetPreviousTimecardClick() {
        this.obtainNewDates(moment(this.state.startDate).add(-2, "day").toDate())
    }

    onGetNextTimecardClick() {
        this.obtainNewDates(moment(this.state.endDate).add(2, "day").toDate())
    }

    onGetThisWeekClick() {
        this.obtainNewDates(moment().toDate())
    }

    onGetLastWeekClick() {
        this.obtainNewDates(moment().subtract(1, "week").toDate())
    }

    onGetToday() {
        this.obtainNewDates(moment().toDate())
    }

    handlePreviousIconMouseOver() {
        this.setState({ previousIconHover: true })
    }

    handlePreviousIconMouseOut() {
        this.setState({ previousIconHover: false })
    }

    handleNextIconMouseOver() {
        this.setState({ nextIconHover: true })
    }

    handleNextIconMouseOut() {
        this.setState({ nextIconHover: false })
    }

    getDates() {
        this.setState({
            startDate: moment(this.state.timecardHintDate).startOf("isoWeek").format(),
            endDate: moment(this.state.timecardHintDate).endOf("isoWeek").format(),
        })
    }

    render() {
        return (
            <div className="EquipmentTimecardActionBar">
                <div style={{ padding: 20 }}>
                    <div style={{ float: "left" }}>
                        <div className="pageHeading" style={{ marginBottom: 3 }}>
                            {strings.Timecard}
                        </div>
                        <div style={{ marginLeft: -15 }}>
                            <div style={{ display: "flex", flexDirection: "row" }}>
                                <div style={{ marginTop: "25px" }}>
                                    <i
                                        className="fa fa-arrow-circle-left"
                                        title={strings.View_previous_timecard}
                                        onClick={this.onGetPreviousTimecardClick}
                                        style={{ color: "#aaaaaa", cursor: "pointer" }}
                                        onMouseOver={this.handlePreviousIconMouseOver}
                                        onMouseOut={this.handlePreviousIconMouseOut}
                                    />
                                    <span style={{ fontSize: 15, marginLeft: 5, marginRight: 5 }}>
                                        {moment(this.state.startDate).format("ddd MMM. DD, YYYY")} &mdash; {moment(this.state.endDate).format("ddd MMM. DD, YYYY")}
                                    </span>
                                    <i
                                        className="fa fa-arrow-circle-right"
                                        title={strings.View_next_timecard}
                                        onClick={this.onGetNextTimecardClick}
                                        style={{ color: "#aaaaaa", cursor: "pointer" }}
                                        onMouseOver={this.handleNextIconMouseOver}
                                        onMouseOut={this.handleNextIconMouseOut}
                                    />
                                </div>
                                <DateButtonsRow
                                    startDay={EDayOfWeek.Monday}
                                    referenceDate={this.state.timecardHintDate}
                                    getThisWeek={this.onGetThisWeekClick}
                                    getLastWeek={this.onGetLastWeekClick}
                                    handleChangeReferenceDate={this.obtainNewDates}
                                />
                            </div>
                        </div>
                    </div>
                    <div style={{ clear: "both" }} />
                </div>
            </div>
        )
    }
}
